<template>
  <div class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>編輯分隊</h3>
          <hr />
        </div>
      </div>
    </div>
    <div class="container">
      <form @submit="onUpdateBtnClick" class="row">
        <div class="col-sm-5 offset-md-6 word_left col-md-offset-4">
          <div class="col-sm-4 fontSize16 selectstyle">分隊名稱:</div>
          <input
            type="text"
            v-model="group.name"
            required=""
            class="inputstyle col-md-6 fontSize16"
            placeholder=""
          />
        </div>
        <div class="col-sm-5 offset-md-6 word_left col-md-offset-4 selectstyle">
          <div class="col-sm-4 fontSize16 selectstyle">聯絡人(或隊長:)</div>
          <select
            v-model="group.manager_id"
            required=""
            class="inputstyle col-md-6 fontSize16"
            name=""
          >
            <option value="">請選擇</option>
            <option v-for="driver in selected_driver_list" :value="driver.id">
              {{ driver.call_number }}
            </option>
          </select>
        </div>
        <div class="col-sm-5 offset-md-6 word_left col-md-offset-4 selectstyle">
          <div class="col-sm-4 fontSize16 selectstyle">聯絡電話:</div>
          <div class="col-sm-4 fontSize16 selectstyle">{{ phone }}</div>
        </div>
        <div class="col-sm-5 offset-md-6 word_left col-md-offset-4 selectstyle">
          <div class="col-sm-4 fontSize16 selectstyle">聯絡電話2:</div>
          <input
            type="text"
            v-model="group.alt_telephone"
            class="inputstyle col-md-6 fontSize16"
            placeholder=""
          />
        </div>
        <div class="col-sm-5 offset-md-6 word_left col-md-offset-4 selectstyle">
          <div class="col-sm-5 fontSize16 selectstyle">目前分隊中司機呼號:</div>
          <textarea
            rows="3"
            class="inputstyle col-md-7 fontSize16"
            v-model="selected_driver"
          ></textarea>
        </div>
        <div class="col-sm-5 offset-md-6 word_left col-md-offset-4 selectstyle">
          <div class="col-sm-5 fontSize16 selectstyle">分隊被刪除司機呼號:</div>
          <textarea
            v-model="removed_driver"
            rows="1"
            class="inputstyle col-md-7 fontSize16"
          ></textarea>
        </div>
        <div class="col-sm-5 offset-md-6 word_left col-md-offset-4">
          <div class="col-sm-5 fontSize16 selectstyle">移除目前分隊中司機:</div>
          <label>
            <span class="checkbox_inline">
              <input
                @click="onAllRemovedClick"
                v-model="all_removed"
                type="checkbox"
                class="flat"
              />
              <span class="fontSize14 textmarginleft">全選</span>
            </span>
          </label>
        </div>
        <div
          class="col-sm-5 offset-md-6 word_left col-md-offset-4 inputstyle black_block textareastyle"
        >
          <label v-for="driver in driver_list.in_group">
            <span class="checkbox_inline">
              <input
                @click="onCheckboxClick"
                v-model="driver.removed"
                :value="driver"
                type="checkbox"
                class="flat"
              />
              <span class="fontSize14 textmarginleft">
                {{ driver.call_number }}
              </span>
            </span>
          </label>
        </div>
        <div class="col-sm-5 offset-md-6 word_left col-md-offset-4">
          <div class="col-sm-5 fontSize16 selectstyle">不在此分隊之司機:</div>
          <label>
            <span class="checkbox_inline">
              <input
                @click="onAllSelectedClick"
                v-model="all_selected"
                type="checkbox"
                class="flat"
              />
              <span class="fontSize14 textmarginleft">全選</span>
            </span>
          </label>
        </div>
        <div
          class="col-sm-5 offset-md-6 word_left col-md-offset-4 inputstyle black_block textareastyle"
        >
          <label v-for="driver in driver_list.free">
            <span class="checkbox_inline">
              <input
                @click="onCheckboxClick"
                v-model="driver.selected"
                :value="driver"
                type="checkbox"
                class="flat"
              />
              <span class="fontSize14 textmarginleft">
                {{ driver.call_number }}
              </span>
            </span>
          </label>
        </div>
        <div class="col-sm-3 offset-md-6 col-md-offset-6">
          <button type="submit" class="mybtnstyle btn-dark textareastyle">
            修改
          </button>
          <button type="button" class="mybtnstyle btn-danger textareastyle">
            取消
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import API from '../../assets/js/libs/API'
import Cookies from 'js-cookie'
import Group from '../../assets/js/libs/Group'
var group = new Group()

export default {
  name: 'GroupDetail',
  data() {
    return {
      driver_list: {
        in_group: [],
        free: [],
      },
      group: {
        id: null,
        name: '',
        manager_id: null,
        alt_telephone: null,
      },
      selected_driver_list: [],
      removed_driver_list: [],
      all_selected: false,
      all_removed: false,
    }
  },
  methods: {
    onCheckboxClick() {
      this.selected_driver_list = []
      this.removed_driver_list = []
    },
    onAllSelectedClick() {
      this.all_selected = !this.all_selected
      this.selected_driver_list = []
      this.driver_list.free.forEach((driver) => {
        driver.selected = this.all_selected
      })
    },
    onAllRemovedClick() {
      this.all_removed = !this.all_removed
      this.selected_driver_list = []
      this.driver_list.in_group.forEach((driver) => {
        driver.removed = this.all_removed
      })
    },
    onUpdateBtnClick(event) {
      event.preventDefault()
      if (confirm('確認修改?')) {
        var data = this.group
        data.drivers = this.selected_driver_list
        group
          .update(this.group.id, data)
          .then((res) => {
            this.$router.replace('/main/groupList')
          })
          .catch((err) => {
            if (err.data.error.type == 'unique') alert(err.data.error.message)
            else console.log(err)
          })
      }
    },
  },
  computed: {
    selected_driver() {
      this.selected_driver_list = []
      // var selected = 0,
      //     removed = 0
      this.driver_list.in_group.forEach((driver) => {
        if (!driver.removed) {
          this.selected_driver_list.push(driver)
          this.all_removed = false
        }
      })
      this.driver_list.in_group.sort((a, b) => {
        return a.call_number - b.call_number
      })
      this.driver_list.free.forEach((driver) => {
        if (driver.selected) this.selected_driver_list.push(driver)
        else this.all_selected = false
      })
      this.selected_driver_list.sort((a, b) => {
        return a.call_number - b.call_number
      })
      return this.selected_driver_list.reduce(
        (accumulator, currentValue, currentIndex) => {
          if (currentIndex === 0) {
            return `${currentValue.call_number}`
          }
          return `${accumulator},${currentValue.call_number}`
        },
        '',
      )
    },
    removed_driver() {
      this.removed_driver_list = []
      this.driver_list.in_group.forEach((driver) => {
        if (driver.removed) this.removed_driver_list.push(driver.call_number)
      })
      this.removed_driver_list.sort((a, b) => a - b)
      return this.removed_driver_list.join(',')
    },
    phone() {
      var phone = null
      this.selected_driver_list.forEach((driver) => {
        if (this.group.manager_id == driver.id) {
          phone = driver.account
          return
        }
      })
      return phone
    },
  },
  mounted() {
    group.getDetail(this.$route.params.id).then((res) => {
      this.group = res.data
      this.driver_list.in_group = res.drivers
      this.driver_list.in_group.map((driver) => {
        driver.removed = false
      })
    })
    group.getSingleDrivers().then((res) => {
      this.driver_list.free = res.list
      this.driver_list.free.map((driver) => {
        driver.selected = false
      })
    })
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/pages/group/GroupDetail.vue